// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-weight: 600;
  font-size: 28px;
  line-height: 34px;
  text-align: center;
  color: #071C3E;
}

.subHeading {
  text-align: center;
  color: #8a8a8a;
}

.shadow {
  width: 160px;
}

.control-select-portal {
  z-index: 1000;
}

.control-select-filter-portal {
  z-index: 999;
}

.fontweight600 {
  font-weight: 600;
}

.header2 .block-limiter {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.header2 .brandhotelselector {
  margin-top: 5px;
}

.bellContainer {
  position: relative;
  width: 50px;
}

.floatRight {
  float: right;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.calender-selection {
  margin-top: 5px;
}

.calender-selection .control-select-men {
  display: inline-block;
  float: left;
}

.calender-selection .control-select-filter-men {
  display: inline-block;
  float: left;
}

.displayInline {
  display: inline !important;
}

.stdcontainer .block-limiter {
  padding: 0 10px 10px 10px;
}

.fullWidthSelect {
  width: 100% !important;
}

.shadow {
  width: 160px;
}

.noShadow {
  box-shadow: none;
}

.resetScoresContainer {
  margin-right: 10px;
}

.resetScoresContainer button {
  background-color: #dafbf9 !important;
  min-width: 60px !important;
  border-color: #dafbf9 !important;
  box-shadow: none !important;
}

.resetScoresContainer .reset-button {
  padding: 5px;
  border-radius: 4px;
  float: right;
}

.resetScoresContainer .reset-button .button-icon-main {
  border-radius: 0;
  background-color: inherit;
  height: 25px;
  width: 25px;
}

.resetScoresContainer .reset-button .button-icon-main .icon {
  color: #2e968f;
}

.resetScoresContainer .reset-button .label {
  text-transform: inherit;
  padding-right: 10px;
  color: #8a8a8a;
  font-weight: normal;
}

.resetScoresContainer .reset-button .button-icon-main svg {
  height: 20px;
  width: 20px;
}

.missedStandardTable table {
  display: block;
  padding-bottom: 88px;
}

.missedStandardTable tr {
  border: 1px solid #E1E1E1;
}

.missedStandardTable table th {
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #1F1F1F;
  text-align: center;
  padding: 15px 15px 15px 10px;
  position: relative;
}

.missedStandardTable table td {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #1F1F1F;
  padding: 15px 15px 15px 10px;
  text-align: center;
}

.missedStandardTable table td:first-child {
  width: 50%;
  text-align: left;
}

.missedStandardTable table th:first-child {
  width: 50%;
  text-align: left;
}

.missedStandardTable th svg {
  position: absolute;
  bottom: 20px;
  margin-left: 5px;
}

.missedStandardTable .tbComplete {
  padding-right: 20px;
}

.missedStandardTable .tbCompletetd {
  padding-right: 20px;
}

.missedStandardTable .paginator {
  list-style: none;
  background: none;
}

.button.layout-default {
  min-width: 70px;
}

.button-filters {
  margin-bottom: 15px;
}

.button-filters button {
  border: 1px solid #e1e1e1;
  border-radius: 60px !important;
  margin-right: 9px;
  min-width: 65px !important;
  color: #afafaf !important;
  height: 24px !important;
  line-height: 24px !important;
}

.button-filters .button .text {
  font-size: 11px;
}

.button-filters .button.active {
  border: 1px solid #4FADA6 !important;
  border-radius: 60px !important;
  margin-right: 10px;
  min-width: 65px !important;
  color: #4FADA6 !important;
  height: 24px !important;
  line-height: 24px !important;
}

.button-filters button.reset {
  border: 1px solid !important;
  border-radius: 60px !important;
  margin-right: 10px;
  min-width: 65px !important;
  color: #000 !important;
  height: 24px !important;
  line-height: 24px !important;
}

.button-filters button {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  color: #919191;
  box-shadow: none !important;
}

.icon-percentage-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 10px;
}

.reset-icon .button-inner svg {
  position: relative;
  top: 0px;
}

.fixed-block {
  transition: 0.5s all ease-in-out;
  top: 8px;
  position: sticky;
  padding-bottom: 10px;
  background-color: white;
}

.fixed-block.active {
  position: sticky;
  z-index: 10;
  top: 80px;
}

.donut-container-missed {
  display: flex;
}

.donut-container-missed .donut {
  width: 114px !important;
  height: 114px !important;
  margin: 13px 0 0 9px;
  align-self: flex-start;
  color: #000;
}

.donut-container-missed .donut-value {
  font-size: 25px !important;
}

.donut-container-missed .donut-change.intent-success {
  font-size: 15px !important;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AACA;EAAG,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,kBAAA;EAAmB,cAAA;AAKzE;;AAJA;EAAY,kBAAA;EAAoB,cAAA;AAShC;;AARA;EAAQ,YAAA;AAYR;;AAXA;EAAuB,aAAA;AAevB;;AAdA;EAA8B,YAAA;AAkB9B;;AAjBA;EAAe,gBAAA;AAqBf;;AAnBA;EAAwB,iBAAA;EAAkB,kBAAA;EAAmB,mBAAA;AAyB7D;;AAxBA;EAA6B,eAAA;AA4B7B;;AA1BA;EAAe,kBAAA;EAAoB,WAAA;AA+BnC;;AA9BA;EAAY,YAAA;AAkCZ;;AAjCA;EAAgB,mBAAA;AAqChB;;AApCA;EAAoB,eAAA;AAwCpB;;AAtCA;EAAwC,qBAAA;EAAuB,WAAA;AA2C/D;;AA1CA;EAA+C,qBAAA;EAAuB,WAAA;AA+CtE;;AA7CA;EAAe,0BAAA;AAiDf;;AAhDA;EAA6B,yBAAA;AAoD7B;;AAnDA;EAAiB,sBAAA;AAuDjB;;AAtDA;EAAQ,YAAA;AA0DR;;AAzDA;EAAU,gBAAA;AA6DV;;AA5DA;EAAsB,kBAAA;AAgEtB;;AA/DA;EAA6B,oCAAA;EAAsC,0BAAA;EAA4B,gCAAA;EAAgC,2BAAA;AAsE/H;;AArEA;EAAoC,YAAA;EAAa,kBAAA;EAAmB,YAAA;AA2EpE;;AA1EA;EAAsD,gBAAA;EAAiB,yBAAA;EAA2B,YAAA;EAAc,WAAA;AAiFhH;;AAhFA;EAA4D,cAAA;AAoF5D;;AAnFA;EAA2C,uBAAA;EAAwB,mBAAA;EAAqB,cAAA;EAAgB,mBAAA;AA0FxG;;AAzFA;EAA0D,YAAA;EAAc,WAAA;AA8FxE;;AA5FA;EACI,cAAA;EACA,oBAAA;AA+FJ;;AA7FA;EAAwB,yBAAA;AAiGxB;;AAhGA;EAA8B,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;EAAgB,kBAAA;EAAmB,4BAAA;EAA6B,kBAAA;AA0GjJ;;AAzGA;EAA8B,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,cAAA;EAAgB,4BAAA;EAA8B,kBAAA;AAkH/H;;AAjHA;EAA0C,UAAA;EAAY,gBAAA;AAsHtD;;AArHA;EAA0C,UAAA;EAAY,gBAAA;AA0HtD;;AAzHA;EAA4B,kBAAA;EAAmB,YAAA;EAAa,gBAAA;AA+H5D;;AA9HA;EAAiC,mBAAA;AAkIjC;;AAjIA;EAAmC,mBAAA;AAqInC;;AApIA;EAAgC,gBAAA;EAAkB,gBAAA;AAyIlD;;AAxIA;EACI,eAAA;AA2IJ;;AAzIA;EAAgB,mBAAA;AA6IhB;;AA5IA;EAAuB,yBAAA;EAA0B,8BAAA;EAA+B,iBAAA;EAAkB,0BAAA;EAA2B,yBAAA;EAA0B,uBAAA;EAAwB,4BAAA;AAsJ/K;;AArJA;EAA8B,eAAA;AAyJ9B;;AAxJA;EAA+B,oCAAA;EAAqC,8BAAA;EAA+B,kBAAA;EAAmB,0BAAA;EAA2B,yBAAA;EAA0B,uBAAA;EAAwB,4BAAA;AAkKnM;;AAjKA;EAA6B,4BAAA;EAA6B,8BAAA;EAA+B,kBAAA;EAAmB,0BAAA;EAA2B,sBAAA;EAAuB,uBAAA;EAAwB,4BAAA;AA2KtL;;AAzKA;EACI,8BAAA;EACJ,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;AA4KA;;AAzKA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA4KJ;;AAzKA;EACI,kBAAA;EACA,QAAA;AA4KJ;;AAnKA;EACI,gCAAA;EACA,QAAA;EAEA,gBAAA;EACA,oBAAA;EACA,uBAAA;AAsKJ;;AAnKA;EAEI,gBAAA;EACA,WAAA;EACA,SAAA;AAsKJ;;AAnKA;EACI,aAAA;AAsKJ;;AAlKA;EACI,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;AAqKJ;;AAnKA;EAAqC,0BAAA;AAuKrC;;AAtKA;EAAqD,0BAAA;AA0KrD","sourcesContent":["h1 {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 34px;\n  text-align: center;\n  color: #071C3E;\n}\n\n.subHeading {\n  text-align: center;\n  color: #8a8a8a;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.control-select-portal {\n  z-index: 1000;\n}\n\n.control-select-filter-portal {\n  z-index: 999;\n}\n\n.fontweight600 {\n  font-weight: 600;\n}\n\n.header2 .block-limiter {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.header2 .brandhotelselector {\n  margin-top: 5px;\n}\n\n.bellContainer {\n  position: relative;\n  width: 50px;\n}\n\n.floatRight {\n  float: right;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.calender-selection {\n  margin-top: 5px;\n}\n\n.calender-selection .control-select-men {\n  display: inline-block;\n  float: left;\n}\n\n.calender-selection .control-select-filter-men {\n  display: inline-block;\n  float: left;\n}\n\n.displayInline {\n  display: inline !important;\n}\n\n.stdcontainer .block-limiter {\n  padding: 0 10px 10px 10px;\n}\n\n.fullWidthSelect {\n  width: 100% !important;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.noShadow {\n  box-shadow: none;\n}\n\n.resetScoresContainer {\n  margin-right: 10px;\n}\n\n.resetScoresContainer button {\n  background-color: #dafbf9 !important;\n  min-width: 60px !important;\n  border-color: #dafbf9 !important;\n  box-shadow: none !important;\n}\n\n.resetScoresContainer .reset-button {\n  padding: 5px;\n  border-radius: 4px;\n  float: right;\n}\n\n.resetScoresContainer .reset-button .button-icon-main {\n  border-radius: 0;\n  background-color: inherit;\n  height: 25px;\n  width: 25px;\n}\n\n.resetScoresContainer .reset-button .button-icon-main .icon {\n  color: #2e968f;\n}\n\n.resetScoresContainer .reset-button .label {\n  text-transform: inherit;\n  padding-right: 10px;\n  color: #8a8a8a;\n  font-weight: normal;\n}\n\n.resetScoresContainer .reset-button .button-icon-main svg {\n  height: 20px;\n  width: 20px;\n}\n\n.missedStandardTable table {\n  display: block;\n  padding-bottom: 88px;\n}\n\n.missedStandardTable tr {\n  border: 1px solid #E1E1E1;\n}\n\n.missedStandardTable table th {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 20px;\n  color: #1F1F1F;\n  text-align: center;\n  padding: 15px 15px 15px 10px;\n  position: relative;\n}\n\n.missedStandardTable table td {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #1F1F1F;\n  padding: 15px 15px 15px 10px;\n  text-align: center;\n}\n\n.missedStandardTable table td:first-child {\n  width: 50%;\n  text-align: left;\n}\n\n.missedStandardTable table th:first-child {\n  width: 50%;\n  text-align: left;\n}\n\n.missedStandardTable th svg {\n  position: absolute;\n  bottom: 20px;\n  margin-left: 5px;\n}\n\n.missedStandardTable .tbComplete {\n  padding-right: 20px;\n}\n\n.missedStandardTable .tbCompletetd {\n  padding-right: 20px;\n}\n\n.missedStandardTable .paginator {\n  list-style: none;\n  background: none;\n}\n\n.button.layout-default {\n  min-width: 70px;\n}\n\n.button-filters {\n  margin-bottom: 15px;\n}\n\n.button-filters button {\n  border: 1px solid #e1e1e1;\n  border-radius: 60px !important;\n  margin-right: 9px;\n  min-width: 65px !important;\n  color: #afafaf !important;\n  height: 24px !important;\n  line-height: 24px !important;\n}\n\n.button-filters .button .text {\n  font-size: 11px;\n}\n\n.button-filters .button.active {\n  border: 1px solid #4FADA6 !important;\n  border-radius: 60px !important;\n  margin-right: 10px;\n  min-width: 65px !important;\n  color: #4FADA6 !important;\n  height: 24px !important;\n  line-height: 24px !important;\n}\n\n.button-filters button.reset {\n  border: 1px solid !important;\n  border-radius: 60px !important;\n  margin-right: 10px;\n  min-width: 65px !important;\n  color: #000 !important;\n  height: 24px !important;\n  line-height: 24px !important;\n}\n\n.button-filters button {\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  align-items: center;\n  color: #919191;\n  box-shadow: none !important;\n}\n\n.icon-percentage-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  row-gap: 10px;\n}\n\n.reset-icon .button-inner svg {\n  position: relative;\n  top: 0px;\n}\n\n.fixed-block {\n  transition: 0.5s all ease-in-out;\n  top: 8px;\n  position: -webkit-sticky;\n  position: sticky;\n  padding-bottom: 10px;\n  background-color: white;\n}\n\n.fixed-block.active {\n  position: -webkit-sticky;\n  position: sticky;\n  z-index: 10;\n  top: 80px;\n}\n\n.donut-container-missed {\n  display: flex;\n}\n\n.donut-container-missed .donut {\n  width: 114px !important;\n  height: 114px !important;\n  margin: 13px 0 0 9px;\n  align-self: flex-start;\n  color: #000;\n}\n\n.donut-container-missed .donut-value {\n  font-size: 25px !important;\n}\n\n.donut-container-missed .donut-change.intent-success {\n  font-size: 15px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
